import React from "react";
import "../../index.css";
import acRepairImage from "../../assets/image/FAQ6.jpg"; // AC Repairing Image

const Faq = () => {
  return (
    <>
      <div className="container-fluid px-md-5 my-5">
        <h2 className="text-primary mb-4 fw-bold" data-aos="fade-right">AC Repairing - FAQs</h2>
        <div className="row align-items-center">
          {/* Left - Image */}
          <div className="col-md-5 text-center">
            <img
              src={acRepairImage}
              alt="AC Repairing"
              className="img-fluid rounded shadow-lg"
              style={{ maxHeight: "350px" }}
              data-aos="fade-right"
            />
          </div>

          {/* Right - Accordion */}
          <div className="col-md-7">
            <div className="accordion shadow-lg rounded" id="faqAccordion" style={{ background: "#f8f9fa", padding: "20px" }}>
              
              {/* Accordion Item 1 */}
              <div className="accordion-item border-0 mb-3 rounded overflow-hidden" data-aos="fade-up">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                    style={{ backgroundColor: "#043681", color: "#fff" }}
                  >
                    Why is my AC not cooling properly?
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                  <div className="accordion-body bg-light p-3 rounded">
                    Your AC may not be cooling due to dirty air filters, low refrigerant levels, blocked condenser coils, or a faulty compressor. Regular maintenance and timely servicing can help avoid these issues.
                  </div>
                </div>
              </div>

              {/* Accordion Item 2 */}
              <div className="accordion-item border-0 mb-3 rounded overflow-hidden" data-aos="fade-up">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                    style={{ backgroundColor: "#043681", color: "#fff" }}
                  >
                    How often should I get my AC serviced?
                  </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                  <div className="accordion-body bg-light p-3 rounded">
                    It is recommended to service your air conditioner at least once a year. For places with heavy usage or high dust levels, twice a year servicing is better to maintain efficient performance.
                  </div>
                </div>
              </div>

              {/* Accordion Item 3 */}
              <div className="accordion-item border-0 mb-3 rounded overflow-hidden" data-aos="fade-up">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                    style={{ backgroundColor: "#043681", color: "#fff" }}
                  >
                    What are common signs that my AC needs repair?
                  </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                  <div className="accordion-body bg-light p-3 rounded">
                    - AC blowing warm air<br />
                    - Strange noises like banging or squealing<br />
                    - Water leakage around the indoor unit<br />
                    - Bad odors coming from the AC<br />
                    - Unusually high electricity bills
                  </div>
                </div>
              </div>

              {/* Accordion Item 4 */}
              <div className="accordion-item border-0 mb-3 rounded overflow-hidden" data-aos="fade-up">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                    style={{ backgroundColor: "#043681", color: "#fff" }}
                  >
                    How long does an AC repair usually take?
                  </button>
                </h2>
                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                  <div className="accordion-body bg-light p-3 rounded">
                    Simple repairs like gas refilling or capacitor replacement can be done within 1–2 hours.<br />
                    Complex repairs like compressor replacement may take up to a full day depending on the issue.
                  </div>
                </div>
              </div>

              {/* Accordion Item 5 */}
              <div className="accordion-item border-0 mb-3 rounded overflow-hidden" data-aos="fade-up">
                <h2 className="accordion-header" id="headingFive">
                  <button
                    className="accordion-button collapsed fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                    style={{ backgroundColor: "#043681", color: "#fff" }}
                  >
                    Is it better to repair or replace an old AC?
                  </button>
                </h2>
                <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#faqAccordion">
                  <div className="accordion-body bg-light p-3 rounded">
                    If your AC is more than 10–12 years old, has frequent breakdowns, or high repair costs, it is often more economical to replace it with a newer, energy-efficient model.
                  </div>
                </div>
              </div>

              {/* Accordion Item 6 */}
              <div className="accordion-item border-0 mb-3 rounded overflow-hidden" data-aos="fade-up">
                <h2 className="accordion-header" id="headingSix">
                  <button
                    className="accordion-button collapsed fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                    style={{ backgroundColor: "#043681", color: "#fff" }}
                  >
                    How much does AC repairing usually cost?
                  </button>
                </h2>
                <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#faqAccordion">
                  <div className="accordion-body bg-light p-3 rounded">
                    The cost depends on the type of issue and parts needed.<br />
                    Minor repairs like cleaning and gas top-up are cheaper, while major repairs like compressor change are costlier.<br />
                    We offer transparent pricing and free diagnosis before starting any repair .
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;
